module.exports = __webpack_public_path__ + "img/ascend-island.0a204876.png";